// extracted by mini-css-extract-plugin
module.exports = {"logo_wrapper":"logo_logo_wrapper__OqECN","logo":"logo_logo__x10mm","hide":"logo_hide__NzEXd"};